<template>
  <DefaultLayout>
    <template slot="top">
      <h1 class="mt-1 title">Questions</h1>
    </template>
    <template slot="center">
      <div class="white-card" style="min-height: 60vh">
        <div class="questions">
          <div class="home-menus bg-white p-0">
            <ul class="home-menu__items">
              <li :class="{'home-menu__link': true, 'active': getMenuClass('all_questions')}"
                  @click="menuItem = 'all_questions'">
                Toutes les questions
              </li>
              <li :class="{'home-menu__link': true, 'active': getMenuClass('questions')}"
                  @click="menuItem = 'questions'">
                Mes questions
              </li>
              <li :class="{'home-menu__link': true, 'active': getMenuClass('responses')}"
                  @click="menuItem = 'responses'">
                Mes Reponses
              </li>
              <!--                    <li :class="{'home-menu__link': true, 'active': getMenuClass('favorites')}" @click="menuItem = 'favorites'">-->
              <!--                      Mes Favoris-->
              <!--                    </li>-->
            </ul>
          </div>
          <div class="px-4">
            <div class="d-flex justify-content-between align-items-center fz-14">
              <span></span>
              <!--              <button type="button"-->
              <!--                      class="border-0 bg-transparent d-flex position-relative text-left align-items-center">-->
              <!--                Les plus pertinentes-->
              <!--                <span class="ml-2 text-orange fa fa-chevron-down"></span>-->
              <!--              </button>-->
              <button @click="$refs.form.show()" class="btn btn-green">
                Ajouter
              </button>
            </div>
          </div>
          <div class="home-content mt-2 px-4 pb-4" v-if="menuItem">
            <div class="loader absolute" v-if="loading"></div>
            <template v-else>
              <template v-if="questions && questions.length">
                <question-component :question="question" class="mt-4" v-for="(question, i) in questions"
                                    :key="i" @refreshData="loadData"></question-component>
              </template>
              <template v-else>
                <p class="text-green text-center mt-5">Aucune élément disponible !</p>
              </template>
            </template>
          </div>
        </div>
      </div>
      <QuestionForm ref="form" v-on:refresh="loadData"/>
    </template>
  </DefaultLayout>
</template>
<script>
import QuestionComponent from "../components/Questions/Question"
import moment from "moment";
import {mapGetters} from "vuex";
import LeftSidebarBottom from '../components/LayoutPartials/LeftSideBarBottom'
import QuestionForm from "@/components/Questions/QuestionForm";
import DefaultLayout from "@/Layout/DefaultLayout";

export default {
  name: 'Questions',
  components: {
    DefaultLayout,
    QuestionForm,
    QuestionComponent,
    LeftSidebarBottom,
  },
  props: {
    backRoute: {type: [String, Object, null], default: null},
  },
  filters: {
    ago: function (data) {
      return moment(data).fromNow();
    }
  },
  data() {
    return {
      menuItem: 'all_questions',
    }
  },
  methods: {
    moment,
    getMenuClass(menu_name) {
      return menu_name === this.menuItem;
    },
    loadData(val) {
      let type = 'all'
      if (this.menuItem === 'questions') {
        type = 'myquestions'
      } else if (this.menuItem === 'responses') {
        type = 'myresponses'
      }
      this.$store.dispatch('question/fetch', {type})
    }
  },
  computed: {
    ...mapGetters({
      'questions': 'question/questions',
      'loading': 'question/loading'
    }),
  },
  watch: {
    menuItem() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style lang="scss">
</style>
